<template>
    <section class="list">
        <header>
            <span>共有{{ commentData.totalCount }}条评价</span>
            <a href="javascript:void(0);" @click="uploadComment">下载评价</a>
        </header>
        <section class="comment">
            <content-component
                v-for="(item, index) in commentData.data"
                :info="item"
                :key="item.id"
            >
            </content-component>
        </section>
        <v-pagination
            :current='currentPage'
            :total='Math.ceil(commentData.totalCount / 20)'
            :size="'md'"
            :first="false"
            :last="false"
            v-on:current-change="currentChangeFunc($event)"
        ></v-pagination>
    </section>
</template>

<style lang="postcss">
    :root {
        --blueColor: #2A99F1;
    }
    .list {
        margin-top: 10px;
        & > header {
            background-color: #FFF;
            height: 46px;
            line-height: 46px;
            padding: 0 30px;
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            & > span {
                color: #828282;
            }
            & > a {
                color: var(--blueColor);
                float: right;
                width: 80px;
                background: url(~static/img/xiazai.png) no-repeat left center;
                text-indent: 20px;
            }
        }
        & .comment {
            background-color: #FFF;
            border-bottom-left-radius: 2px;
            border-bottom-right-radius: 2px;
        }
        & > div {
            text-align: center;
            & .pagination {
                & li {
                    &.active span {
                        background-color: var(--blueColor);
                        border-color: var(--blueColor);
                    }
                    & a {
                        color: var(--blueColor);
                        background-color: #FFF;
                    }
                }
            }
        }
    }
</style>

<script>
    import ContentComponent from './Content.vue'
    import Comment from 'api/comment'
    import { eventBus } from 'helpers/index'
    import { Lazy_Img_Src, Lazy_Load_Attr } from "config/packageProduct";

    export default {
        components: {
            ContentComponent
        },
        data () {
            return {
                channel: '1', // 当前展示平台 1 美团 2 点评
                tag: '', // 标签
                replyType: '1', // 回复情况 1 全部 2 未回复
                startDate: '', // 开始日期
                endDate: '', // 结束日期
                starLevels: '', // 星级
                contentType: '0', // 有无内容 0 全部 1 有内容 2 无内容
                commentData: { // 评论列表数据
                    data: [],
                    totalCount: 0
                },
                renderType: 1, // 当前渲染的逻辑 1 根据回复情况 2 根据标签 3 根据日期星级 4 根据有无内容
                currentPage: 1 // 当前页
            }
        },
        props: ['did'],
        mounted(){
           this.workSpaceEle = document.querySelector('.work-space');
           if(this.workSpaceEle) {
               this.workSpaceEle.addEventListener('scroll',this.updateImgs)
           };
        },
        destroyed(){
            if(this.workSpaceEle) {
                this.workSpaceEle.removeEventListener('scroll',this.updateImgs)
            }
        },
        methods: {
            // 根据回复情况获取评价
            getDataForReply () {
                if (!this.did) {
                    return
                }
                if(this.isRequesting) {
                    return;
                }
                this.$emit('changeLoading', true)
                this.isRequesting = true;
                Comment.getCommentsForReply(this.did, this.channel, this.replyType, this.currentPage)
                    .then((res) => {
                        this.renderData(res);
                        this.isRequesting = false;
                    })
                    .catch((err) => {
                        console.log(err)
                        this.$emit('changeLoading', false)
                        this.$notify.error({
                            title: '错误',
                            message: err.message || '出错了，请稍后再试'
                        })
                    })
            },

            // 根据标签获取评价
            getDataForTags () {
                if (!this.did) {
                    return
                }
                this.$emit('changeLoading', true)
                Comment.getCommentsForTag(this.did, this.channel, this.tag, this.currentPage)
                    .then((res) => {
                        this.renderData(res)
                    })
                    .catch((err) => {
                        console.log(err)
                        this.$emit('changeLoading', false)
                        this.$notify.error({
                            title: '错误',
                            message: err.message || '出错了，请稍后再试'
                        })
                    })
            },

            // 根据日期、星级获取评价
            getDataForOthers () {
                if (!this.did) {
                    return
                }
                this.$emit('changeLoading', true)
                Comment.getCommentsForOthers(this.did, this.channel, this.startDate, this.endDate, this.starLevels, this.currentPage)
                    .then((res) => {
                        this.renderData(res)
                    })
                    .catch((err) => {
                        console.log(err)
                        this.$emit('changeLoading', false)
                        this.$notify.error({
                            title: '错误',
                            message: err.message || '出错了，请稍后再试'
                        })
                    })
            },

            // 根据有无内容获取评价
            getDataForContent () {
                if (!this.did) {
                    return
                }
                this.$emit('changeLoading', true)
                Comment.getCommentsForContent(this.did, this.contentType, this.currentPage)
                    .then((res) => {
                        this.renderData(res)
                    })
                    .catch((err) => {
                        console.log(err)
                        this.$emit('changeLoading', false)
                        this.$notify.error({
                            title: '错误',
                            message: err.message || '出错了，请稍后再试'
                        })
                    })
            },

            // 渲染数据
            renderData (res) {
                if (res.status !== 0) {
                    this.$notify.error({
                        title: '错误',
                        message: err.message || '出错了，请稍后再试'
                    })
                    this.$emit('changeLoading', false)
                    return
                } else {
                    this.commentData.data = res.data
                    this.$nextTick(()=>{
                        this.updateImgs();
                    });
                    this.commentData.totalCount = res.totalCount
                    document.body.scrollTop = 0
                    this.$emit('changeLoading', false)
                }
            },
            updateImgs(ev){
                let target = ev && ev.target || this.workSpaceEle;
                if(target) {
                    let imgs = [...target.querySelectorAll('img['+Lazy_Load_Attr+']')];
                    if(!imgs || !imgs.length) return;
                    let { clientHeight, clientWidth } = document.body;
                    imgs.forEach((img)=>{
                        if(img.getAttribute('src') === Lazy_Img_Src) {
                            let {height,width,top,left} = img.getBoundingClientRect();
                            if(top + height > 0 && top + height < clientHeight && left + width > 0 && left + width < clientWidth) {
                                img.setAttribute('src',img.getAttribute(Lazy_Load_Attr));
                                img.removeAttribute(Lazy_Load_Attr);
                            }
                        }
                    });
                }
            },
            // 切换页码
            currentChangeFunc: function (data) {
                this.currentPage = data.current
                switch (this.renderType) {
                    case 1: this.getDataForReply()
                        break
                    case 2: this.getDataForTags()
                        break
                    case 3: this.getDataForOthers()
                        break
                    case 4: this.getDataForContent()
                        break
                    default: this.getDataForReply()
                        break
                }
            },

            // 下载评价
            uploadComment () {
                Comment.uploadComment(this.did, this.channel)
            }
        },
        created () {
            // 初始化
            this.getDataForReply()
            // 监听标签变化
            eventBus.$on('getDataForTags', params => {
                this.did = params.did
                this.channel = params.channel
                this.tag = params.tag
                this.currentPage = 1
                this.renderType = 2
                this.getDataForTags()
            })
            // 监听回复情况变化
            eventBus.$on('getDataForReply', params => {
                this.did = params.did
                this.channel = params.channel
                this.replyType = params.replyType
                this.currentPage = 1
                this.renderType = 1
                this.getDataForReply()
            })
            // 监听日期、星级变化
            eventBus.$on('getDataForOthers', params => {
                this.did = params.did
                this.channel = params.channel
                this.startDate = params.startDate
                this.endDate = params.endDate
                this.starLevels = params.starLevels
                this.currentPage = 1
                this.renderType = 3
                this.getDataForOthers()
            })
            // 监听有无内容变化
            eventBus.$on('getDataForContent', params => {
                this.did = params.did
                this.contentType = params.contentType
                this.currentPage = 1
                this.renderType = 4
                this.getDataForContent()
            })
        }
    }
</script>



// WEBPACK FOOTER //
// List.vue?6b780b14